import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=30469bac&scoped=true"
import script from "./Shortcuts.vue?vue&type=script&lang=js"
export * from "./Shortcuts.vue?vue&type=script&lang=js"
import style0 from "./Shortcuts.vue?vue&type=style&index=0&id=30469bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30469bac",
  null
  
)

export default component.exports